module.exports = __webpack_public_path__ + "img/faq_split.7d1ab92b.png";